import { createJob } from './jobs';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export const createAsset = (model, data) => async (dispatch, getState) => {
  const job = await dispatch(createJob(model, data));
  return job;
};



// WEBPACK FOOTER //
// ./src/modules/assets.js